export default {
  faces: {
    created: "作成しました。",
    updated: "更新しました。",
  },
  repairs: {
    created: "作成しました。",
    updated: "更新しました。",
  },
  materials: {
    created: "作成しました。",
    updated: "更新しました。",
  },
  floors: {
    created: "作成しました。",
  },
  properties: {
    must_be_select_floor_plan: "修繕情報を登録するには、先に間取り図を選択してください。",
    updated: "更新しました。",
    created: "作成しました。",
    can_not_created: "物件情報を作成できませんでした。",
    deleted: "削除しました。",
    no_result: "データは登録されていません。",
    duplicate: "コピーを作成しました",
    bulk_edit_success: "更新しました",
    bulk_edit_not_change: "編集項目がありません",
    must_be_a_property: "一括編集を行う物件にチェックを挿入してください",
    can_not_change_manage_company: "譲渡に同意していない物件が含まれているため、管理会社の一括変更はできません。",
  },
  repairContents: {
    created: "作成しました。",
    can_not_create: "修繕が作成できませんでした。",
    updated: "更新しました。",
    deleted: "削除しました。",
    no_result: "データは登録されていません。",
  },
  contracts: {
    created: "作成しました。",
    updated: "更新しました",
    deleted: "削除しました",
    no_result: "データは登録されていません。",
    content_invite: "{company_name}の{user_name}様からJ-SYSTEMへの招待が届きました。\n承認すると、ログイン画面へ遷移いたします。",
    contract_was_accepted: "受理されました。",
    accepted: "承認しました",
    rejected: "非承認しました",
    contract_was_expired: "契約が完了しました",
    confirmed: "確認しました",
  },
  contractConfirm: {
    area_required: "エリアは必須項目です。",
    comment_required: "コメントは必須項目です。",
  },
  contractFieldNames: {
    contractor_id: '契約担当',
    type: '契約者種別',
    no: '契約番号',
    move_in_date: '入居日',
    contractor_name: '契約者名',
    contractor_name2: '契約者名フリガナを入力',
    contractor_phone: '契約者TEL',
    resident_name: '入居者名',
    resident_name2: '入居者名フリガナを入力',
    resident_phone: '入居者TEL',
    j_sys_id: 'J-SYS ID',
    bank_account_information: '口座情報',
    property_id: '契約物件',
    image_id: '返却物品画像',
    returned_items: '返却物品リスト',
    security_deposit: '敷金',
    rent: '賃料',
    common_service_fee: '共益費',
    town_membership_fee: '町会費',
    deposit: '保証金',
    depreciation: '償却',
    addition_items: 'その他項目',
    files: '契約書類',
    withdrawal_application: '退会申請',
    status: "最終確認",
  },
  contractMoveOutStatus: {
    0: '退去申請',
    1: '日程調整',
    2: 'CL作成',
    3: 'CL添削',
    4: 'CL添削',
    5: 'CL添削',
    6: 'CL完了',
    7: '修繕依頼',
    8: '修繕依頼',
    9: '報告書作成',
    10: '完了',

    // 0: '退去申請', // manage
    // 1: '日程調整', // manage
    // 2: 'CL作成', // witness
    // 3: 'CL添削', // all
    // 4: 'CL完了', // none
    // 5: '修繕依頼', // manager or witness
    // 6: '報告書作成', // witness
    // 7: '完了', // none

    // 3: 'CL添削', // all
    // 4: 'CL完了', // none
    // 5: '修繕依頼', // manager or witness
    // 6: '報告書作成', // witness
    // 7: '完了', // none
  },
  contractMoveOuts: {
    no_result: "データは登録されていません",
    success_step_2: "Successed", // scheule
    success_step_3: "Successed", // checklist
    success_step_4: "Successed", // signature
    success_step_5: "Successed", // signature
    discar_resign: "Successed", // signature
    go_back: "Successed",
    must_be_sign: "署名は必須項目です。"
  },
  contractMoveOutFieldName: {
    floor_area_id: '間取り図エリア',
    master_direction_id: '方位',
    face_id: '面',
    material_id: '材料',
    repair_detail_id: '修繕内容',
    remarks: '特記事項',
    quantity: '数量',
    unit_name_id: '単位',
    unit_price: '単価',
    ratio_price: '負担割合',
    resident_price: '入居者負担額',
    owner_price: 'オーナー負担額',
    total_price: '総額金額',
  },
  me: {
    updated: "更新しました"
  },
  upload: {
    max_size: " {filename} は10MBを超えているためアップロードできません",
  },
  contractHistoriesFromat: {
    1: "「{createdBy}」さんが「{contractName}」さんの契約情報を登録しました。",
    2: "「{createdBy}」さんが「{itemName}」を「{oldValue}」から「{newValue}」へ更新しました。",
    3: "「{createdBy}」さんが退去申請をしました。",
    4: "「{createdBy}」さんが契約書類の「{filename}」を追加しました。",
    5: "「{createdBy}」さんが契約書類の「{filename}」を削除しました。",
    6: "「{createdBy}」さんが返却物品画像を更新しました。",
    7: "「{createdBy}」さんが契約書類を更新しました。",
  },
  users: {
    wrong_re_password: "ご入力いただいたパスワードが一致しません。",
    regex_password: "パスワードは半角英数8文字以上で入力してください。",
    no_result: "該当データは見つかりませんでした。",
    delete_cooperation: "\"{user_name}\"との連携を解除します。この操作は取り消しできません。",
    cooperation_deleted: "削除しました",
    cooperation_updated: "更新しました",
    cooperation_created: "作成しました",
    created: "作成しました。",
    updated: "更新しました",
    deleted: "削除しました",
    created_fail: "アカウントが作成できませんでした。",
    deleted_fail: "アカウントを削除できませんでした。",
    cooperation_created_fail: "アカウントを連携できませんでした。",
    cooperation_deleted_fail: "連携を削除できませんでした。",
    cooperation_rejected: "却下しました",
    cooperation_accepted: "承認しました",
  },
  cancel: "変更内容を破棄して編集を終了します。この操作は取り消せません。",
  delete: "削除を実行します。この操作は取り消せません。",
  deleteCooperate: "\"{company_name}\"との連携を解除します。この操作は取り消しできません。",
  errors: {
    not_found: "Not Found",
  },
  common: {
    zip_code_not_found: "所在地は見つかりません。",
    zip_code_required: "転居先は必須項目です。",
    phone_format_is_valid: "電話番号の形式に誤りがあります。",
    fax_format_is_valid: "FAX番号の形式に誤りがあります。",
  },
  recover: "編集中のデータがあるため復元します。",
  role: {
    0: '管理者',
    1: '管理会社スタッフ',
    2: '立会業者スタッフ',
    3: 'オーナースタッフ',
  },
  forbiden: "forbiden",
  companies: {
    created: "作成しました。",
    updated: "更新しました",
    deleted: "削除しました",
    cooperate_deleted: "削除しました",
    cooperate_updated: "更新しました",
    created_fail: "会社が作成できませんでした。",
    updated_fail: "会社情報を更新できませんでした。",
    cooperate_deleted_fail: "パートナーを削除できませんでした。",
    cooperation_created_fail: "パートナーを連携できませんでした",
    no_result: "該当データは見つかりませんでした。",
    license_is_not_active: "{applicable_date}からご利用いただけます。",
  },
  not_changed: "項目が入力されていません",
  confirm_text: {
    yes: "はい",
  },
  forgot_password: {
    expired_token: "こちらのURLは有効期限が切れております。\nお手数ですが、再度パスワードの再設定手続きから行ってください。",
    invalid_token: "無効なトークンです"
  },
  move_out: {
    exact_address_required: "転居先は必須項目です。",
    exact_address_max_length: "住所は最大255文字です。",
    phone_required: "連絡先は必須項目です。",
    move_out_date_required: "退去日は必須項目です。",
    desired_date_1_required: "第1希望は必須項目です。",
    desired_date_2_required: "第2希望は必須項目です。",
    desired_date_3_required: "第3希望は必須項目です。",
    message_required: "メッセージを入力してください",
  },
  talk_room: {
    file_upload_over_size_is_10: "10MB未満の画像をアップロードしてください。"
  },
  dashboard: {
    talk_room: {
      contractor: "{property_name} {room_number}の{user_name}さんからメッセージが届いています。",
      staff: "{user_name}さん（{company_name}）からメッセージが届いています。",
    }
  },
  data_was_transfered: "データがありません。",
  router_not_permission: "unauthority",
  download_files: {
    dm_10_file: '{filename}_退去精算依頼書.pdf',
    dm_20_file: '{filename}_チェックリスト確認書.pdf',
    dm_30_file: '{filename}_DM_30.pdf',
    dm_40_file: '{filename}_御見積書.pdf',
    dm_50_file: '{filename}_発注書.pdf',
    dm_60_file: '{filename}_原状回復工事報告書.pdf',
  },
  switch_role_pattern:{
    0: '{role_name}',
    1: '{company_name}（管理会社スタッフ）',
    2: '{company_name}（{affiliation_company_name}スタッフ）',
    3: '{company_name}（{affiliation_company_name}スタッフ）',
  },
  messages: {
    placeholder_input: 'メッセージを入力',
    conversation_date_on: 'Conversation started on: {date}'
  }
};
